export default __webpack_public_path__ + "static/media/uploadCn3.1ea3ac06.jpg";